import { EVENT_BUS } from '@bto-services/event-bus';
import store from '../../../../store';
import { BETSLIP_STATUS } from 'bto-models/betslip';
import CashoutService from '../../../../services/mybets/cashout-request-service';
import { CASHOUT_ERROR_CODES } from '../../../../models/enums/mybets-const';

export default {
  data() {
    return {
      CASHED_OUT: BETSLIP_STATUS.CACHEDOUT,
      LOST: BETSLIP_STATUS.LOST,
      WON: BETSLIP_STATUS.WON,
      REJECTED: BETSLIP_STATUS.REJECTED,
      cashoutCircularLoader: false,
      cashoutStep: 0,
      cashoutBtnName: '',
      cashoutNewOffer: 0,
      cashoutAmount: 0,
    };
  },
  props: {
    bet: {
      type: Object,
      required: true,
    },
    timeOut: {
      type: Number,
    },
  },
  computed: {
    getCashout() {
      return store.getters.getCashoutByBetslipGroupId(this.bet.betSlipGroupID);
    },
    // Cashout for new design
    showCashout() {
      return this.bet.betSlipGroupStatusId === BETSLIP_STATUS.PLACED;
    },
    cashoutVal() {
      return this.cashoutNewOffer || store.getters.getCashoutByBetslipGroupId(this.bet.betSlipGroupID);
    },
  },
  methods: {
    checkStatus(status) {
      return this.bet.betSlipGroupStatusId === status;
    },
    // Cashout for new design
    cashedOutMsgHandler(resp) {
      const betId = this.bet.betSlipGroupID;
      if (resp.BetslipGroupId === betId) {
        if (this.IS_AGENT) {
          this.handleAgentCashout(resp);
        } else {
          this.cashedOutResp(resp);
        }
      }
    },
    processCashout(cashoutValue) {
      const cashoutService = new CashoutService();
      switch (this.cashoutStep) {
        // first click ask for confirmation
        case 0:
          this.cashoutStep = 1;
          this.cashoutBtnName = this.$translate.text('Mobile.confirmcashout');
          break;
        case 1:
        case 3: {
          const betId = this.bet.betSlipGroupID;
          cashoutService.postParams.betSlipGroupID = betId;
          cashoutService.postParams.Amount = cashoutValue;
          this.cashoutCircularLoader = true;
          cashoutService.execute();
          break;
        }
        default:
          this.cancelCashout();
      }
    },
    cashedOutResp(resp) {
      this.cashoutCircularLoader = false;
      if (resp.ErrorCode === CASHOUT_ERROR_CODES.NEW_OFFER && resp.Amount) {
        this.cashoutStep = 3;
        this.cashoutBtnName = this.$translate.text('W.acceptcashout');
        this.cashoutMsg = this.$translate.text('W.changedcashout');
        this.cashoutNewOffer = resp.Amount;
        return;
      }
      if (resp.ErrorCode === CASHOUT_ERROR_CODES.ERROR) {
        this.cancelCashout(resp.Message);
        return;
      }
      if (resp.ErrorCode === CASHOUT_ERROR_CODES.SUCCESS) {
        const betId = this.bet.betSlipGroupID;
        this.$emit('cashedOutBetToRemove', betId);
        this.cashoutStep = 4;
        this.cashoutBtnName = resp.Message;
        this.cashoutMsg = resp.Message;
        this.cashoutAmount = resp.Amount;
        this.isDisabled = true;
        return;
      }
      this.cashoutStep = 2;
      this.cashoutMsg = resp.Message;
      this.cashoutNewOffer = 0;
    },
    cancelCashout(msg = '') {
      this.cashoutStep = 0;
      this.cashoutMsg = msg;
      this.cashoutBtnName = this.$translate.text('BetSlip.cashout.cashoutButton');
      this.isDisabled = false;
    },
  },
  created() {
    this.cashoutBtnName = this.$translate.text('BetSlip.cashout.cashoutButton');
    EVENT_BUS.$on('cashedOutMsg', this.cashedOutMsgHandler);
  },
  destroyed() {
    EVENT_BUS.$off('cashedOutMsg', this.cashedOutMsgHandler);
  },
};